module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('affix', {
    staticClass: "col-md-4 vue-affix",
    attrs: {
      "enabled": (_vm.windowWidth > 991),
      "relative-element-selector": "#form-builder-content",
      "offset": {
        top: 90,
        bottom: 0
      }
    }
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-settings font-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Editing")])]), _vm._v(" "), (!_vm.loading) ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 'fields'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('fields')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#form-sidebar-elements",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Fields ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'conditions'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('conditions')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#form-sidebar-conditions",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                Conditions ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'settings'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('settings')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#form-sidebar-settings",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Settings ")])])]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "tab-content form-sidebar-tab"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "tab-pane vb",
    class: {
      active: _vm.activeTab === 'fields'
    },
    attrs: {
      "id": "form-sidebar-elements"
    }
  }, [_c('div', [(_vm.module.role === 'referral') ? _c('referral-add-field-from-profile', {
    attrs: {
      "schema": _vm.schema
    },
    on: {
      "update-form": _vm.updateForm
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-form-builder-field-list', {
    attrs: {
      "include-destination-account-field": _vm.includeDestinationAccountField,
      "include-programs-checkbox-group-field": _vm.includeProgramsCheckboxGroupField
    },
    on: {
      "shared-field-added": function($event) {
        _vm.sharedFields[$event] = {};
      },
      "drag-started": _vm.openSettingsTab
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "tab-pane vb",
    class: {
      active: _vm.activeTab === 'conditions'
    },
    attrs: {
      "id": "form-sidebar-conditions"
    }
  }, [_c('div', [_c('vue-form-conditions-editor', {
    attrs: {
      "schema": _vm.schema,
      "flat-schema": _vm.flatSchema,
      "conditions": _vm.conditions,
      "validation-conditions": _vm.validationConditions,
      "hide-values": _vm.hideValues,
      "calculations": _vm.calculations,
      "update-conditions": _vm.updateConditions
    }
  }), _vm._v(" "), (_vm.module.key === 'participants_assignment') ? _c('vue-program-status-conditions', {
    ref: "programStatusConditions",
    attrs: {
      "schema": _vm.flatFormItems
    },
    model: {
      value: (_vm.systemConditions.programStatus),
      callback: function($$v) {
        _vm.$set(_vm.systemConditions, "programStatus", $$v)
      },
      expression: "systemConditions.programStatus"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "tab-pane vb",
    class: {
      active: _vm.activeTab === 'settings'
    },
    attrs: {
      "id": "form-sidebar-settings"
    }
  }, [_c('div', [_c('form', {
    attrs: {
      "data-vv-scope": "settings_form"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.Form Name')
    }
  }, [_c('label', {
    attrs: {
      "for": "form-name"
    }
  }, [_vm._v("Form Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "form-name",
      "name": "Form Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.Form Name')),
      expression: "errors.has('settings_form.Form Name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.Form Name')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.Description')
    }
  }, [_c('label', {
    attrs: {
      "for": "form-desc"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "form-desc",
      "name": "Description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.Description')),
      expression: "errors.has('settings_form.Description')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.Description')))])]), _vm._v(" "), (_vm.type == 'form' && !this.lockModule && this.module.role != 'referral') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.Related to')
    }
  }, [_c('label', [_vm._v("Related to")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleKey),
      expression: "moduleKey"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Related to"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.modulesList), function(module) {
    return _c('option', {
      domProps: {
        "value": module.key
      }
    }, [_vm._v(_vm._s(module.name))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.Related to')),
      expression: "errors.has('settings_form.Related to')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.Related to')))])]) : _vm._e(), _vm._v(" "), (['organization_organization', 'organization_general', 'assessment_outcomes', 'activities_services'].includes(_vm.module.key)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.access_level')
    }
  }, [_c('label', [_vm._v("User access")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accessLevel),
      expression: "accessLevel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Access level",
      "data-vv-as": "Access Level",
      "data-vv-name": "access_level"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.accessLevel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.accessLevels), function(accessLevel) {
    return _c('option', {
      domProps: {
        "value": accessLevel.key
      }
    }, [_vm._v(_vm._s(accessLevel.name))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.access_level')),
      expression: "errors.has('settings_form.access_level')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.access_level')))])]) : _vm._e(), _vm._v(" "), (_vm.module.role === 'referral') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.referral_email_contact')
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "referral_email_contact"
    }
  }, [_vm._v("Email Address (Referral Contact, Status Notification)")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.referralDestinationEmail),
      expression: "referralDestinationEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": 'referral_email_contact',
      "data-vv-as": 'Email Address',
      "id": "referral_email_contact"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.referralDestinationEmail = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.flatFormItems), function(field) {
    return (['email'].includes(field.type)) ? _c('option', {
      domProps: {
        "value": field.name
      }
    }, [_vm._v("\n                      " + _vm._s(field.description) + "\n                    ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.referral_email_contact')),
      expression: "errors.has('settings_form.referral_email_contact')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.referral_email_contact')))])]) : _vm._e(), _vm._v(" "), (_vm.displayInOrganizationsSelect) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.form_accounts')
    }
  }, [(_vm.module.role === 'referral') ? _c('label', [_vm._v("Display Following Organizations")]) : _c('label', [_vm._v("Display in following organizations")]), _vm._v(" "), _c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate:accounts",
      value: ('accounts_arr|required'),
      expression: "'accounts_arr|required'",
      arg: "accounts"
    }],
    attrs: {
      "options": _vm.currentOrganization.accountType === 'parent' ? _vm.childrenAccounts : _vm.userAccounts,
      "label": "organizationName",
      "value": "accounts",
      "multiple": true,
      "maxHeight": "300px",
      "data-vv-name": 'form_accounts'
    },
    on: {
      "input": _vm.onDisplayInOrganizationsInput
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.organizationName) + "\n                    ")]
      }
    }], null, false, 2201269293),
    model: {
      value: (_vm.accounts),
      callback: function($$v) {
        _vm.accounts = $$v
      },
      expression: "accounts"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.form_accounts')),
      expression: "errors.has('settings_form.form_accounts')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.form_accounts')))])], 1) : _vm._e(), _vm._v(" "), (_vm.currentOrganization.accountType === 'program' && ['assessment_outcomes', 'activities_services'].includes(_vm.module.key)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.display_in_programs')
    }
  }, [_c('label', [_vm._v("Display in following Programs")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "options": _vm.activeAvailablePrograms,
      "label": "name",
      "value": "id",
      "multiple": true,
      "maxHeight": "300px"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n                      " + _vm._s(option.name) + "\n                    ")]
      }
    }], null, false, 160376022),
    model: {
      value: (_vm.formPrograms),
      callback: function($$v) {
        _vm.formPrograms = $$v
      },
      expression: "formPrograms"
    }
  })], 1) : _vm._e(), _vm._v(" "), (['assessment_outcomes', 'activities_services', 'organization_organization', 'organization_general'].includes(_vm.module.key)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('settings_form.multiple_entries')
    }
  }, [_c('label', [_vm._v("Numbers of Entries Allowed")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multipleEntries),
      expression: "multipleEntries"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Multiple entries"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.multipleEntries = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("One entry")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Multiple entries")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('settings_form.multipleEntries')),
      expression: "errors.has('settings_form.multipleEntries')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('settings_form.multipleEntries')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group spacing-button"
  }, [_c('button', {
    staticClass: "btn green dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Add spacing\n                    "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSpacing(['row'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-h"
  }), _vm._v("\n                        Add spacing after each row\n                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSpacing(['divider'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-window-minimize",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        Add divider after each row\n                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSpacing(['divider', 'row'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-h",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        Add divider and spacing after each row\n                      ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSpacing([])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                        Remove all spacing and dividers\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "margin-bottom-0"
  }, [_vm._v("Make this form globally available")]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "sync": true,
      "labels": true
    },
    model: {
      value: (_vm.isGlobal),
      callback: function($$v) {
        _vm.isGlobal = $$v
      },
      expression: "isGlobal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "margin-bottom-0"
  }, [_vm._v("Share fields from this form")]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "sync": true,
      "labels": true
    },
    on: {
      "change": function($event) {
        _vm.hasSharedFields && _vm.openShareFieldsModal()
      }
    },
    model: {
      value: (_vm.hasSharedFields),
      callback: function($$v) {
        _vm.hasSharedFields = $$v
      },
      expression: "hasSharedFields"
    }
  }), _vm._v(" "), (_vm.hasSharedFields) ? _c('button', {
    staticClass: "btn btn-xs green shared-settings-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openShareFieldsModal
    }
  }, [_vm._v("\n                    Edit\n                  ")]) : _vm._e()], 1), _vm._v(" "), (['activities_services', 'assessment_outcomes'].includes(_vm.module.role)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "margin-bottom-0"
  }, [_vm._v("Share with " + _vm._s(_vm.participantSingularName))]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "sync": true,
      "labels": true
    },
    on: {
      "change": function($event) {
        _vm.shareWithParticipant && _vm.openShareWithParticipantModal()
      }
    },
    model: {
      value: (_vm.shareWithParticipant),
      callback: function($$v) {
        _vm.shareWithParticipant = $$v
      },
      expression: "shareWithParticipant"
    }
  }), _vm._v(" "), (_vm.shareWithParticipant) ? _c('button', {
    staticClass: "btn btn-xs green shared-settings-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openShareWithParticipantModal
    }
  }, [_vm._v("\n                    Edit\n                  ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['referral'].includes(_vm.module.role)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "margin-bottom-0"
  }, [_vm._v("Enable reCaptcha")]), _vm._v(" "), _c('toggle-button', {
    class: 'margin-bottom-0',
    attrs: {
      "sync": true,
      "labels": true
    },
    model: {
      value: (_vm.captchaEnabled),
      callback: function($$v) {
        _vm.captchaEnabled = $$v
      },
      expression: "captchaEnabled"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.module.role !== 'referral') ? _c('vue-map-data', {
    ref: "mapData",
    attrs: {
      "flat-form-items": _vm.flatFormItems,
      "is-form": _vm.type === 'form',
      "is-program": _vm.currentOrganization.accountType === 'program',
      "custom-columns-map": _vm.customColumnsMap,
      "columns-map": _vm.module.columns_map,
      "fields-map": _vm.columnsMap,
      "allow-adding-custom-fields": ['participants_profile', 'members_profile', 'participants_assignment'].includes(this.module.key)
    },
    on: {
      "update": _vm.updateMapData
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isFormLocked) ? _c('button', {
    ref: "saveFormBtn",
    staticClass: "btn green mt-ladda-btn ladda-button save-form-btn",
    attrs: {
      "data-style": "expand-left",
      "id": "save-form-button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveChanges.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Save Changes")])]) : _vm._e(), _vm._v(" "), (!_vm.isFormLocked && _vm.type === 'form' && (!(['profile', 'assignment'].includes(_vm.module.role)) || !_vm.formPublish)) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.publishForm(false)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.publishText) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isFormLocked) ? _c('router-link', {
    staticClass: "btn default",
    attrs: {
      "to": "/admin/form-builder",
      "tag": "button"
    }
  }, [_vm._v("\n            Cancel\n          ")]) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "id": "form-builder-content"
    }
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lockForm.apply(null, arguments)
      }
    }
  }, [(_vm.isFormLocked) ? _c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-unlock-alt",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.duplicateForm
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.expandForm
    }
  }, [(_vm.isExpand) ? _c('i', {
    staticClass: "fa fa-minus-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-plus-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (!_vm.isFormLocked && (_vm.appUser.access == 6 || _vm.module.group != 'core')) ? _c('li', {
    on: {
      "click": _vm.formRemove
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.renderForm
    }
  }, [_c('a', {
    attrs: {
      "href": "#form_preview",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Preview ")])]), _vm._v(" "), (_vm.shareWithParticipant) ? _c('li', {
    on: {
      "click": _vm.renderForm
    }
  }, [_c('a', {
    attrs: {
      "href": "#form_preview_participant",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" " + _vm._s(_vm.participantSingularName) + " Preview ")])]) : _vm._e(), _vm._v(" "), (_vm.module.role === 'referral') ? [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "form-settings"
    }
  }, [_c('vue-form-editor', {
    key: 'main-editor',
    attrs: {
      "schema": _vm.schema,
      "shared-fields": _vm.sharedFields,
      "share-with-participant": _vm.shareWithParticipant,
      "id": _vm.id
    },
    on: {
      "field-removed": _vm.onFieldRemoved
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "form_preview"
    }
  }, [_c('vue-form-render', {
    attrs: {
      "schema": _vm.schema,
      "conditions": _vm.conditions,
      "update-conditions": _vm.updateConditions,
      "calculations": _vm.calculations,
      "systemConditions": _vm.systemConditions,
      "validation-conditions": _vm.validationConditions,
      "hideValues": _vm.hideValues,
      "date-format": _vm.appUser.date_format,
      "user-access-level": _vm.appUser.access,
      "referral-destination-accounts": _vm.referralDestinationAccounts,
      "programs": _vm.activeAvailablePrograms,
      "form-previews": _vm.formPreviews
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.shareWithParticipant) ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "form_preview_participant"
    }
  }, [_c('vue-form-render', {
    attrs: {
      "schema": _vm.schema,
      "conditions": _vm.conditions,
      "update-conditions": _vm.updateConditions,
      "calculations": _vm.calculations,
      "systemConditions": _vm.systemConditions,
      "validation-conditions": _vm.validationConditions,
      "hideValues": _vm.hideValues,
      "date-format": _vm.appUser.date_format,
      "user-access-level": _vm.appUser.access,
      "referral-destination-accounts": _vm.referralDestinationAccounts,
      "programs": _vm.activeAvailablePrograms,
      "formblock": _vm.participantSubmissionLockFields,
      "is-participant-submission": true,
      "form-previews": _vm.formPreviews
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.module.role === 'referral') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "form_share"
    }
  }, [_c('vue-form-share-links', {
    attrs: {
      "url": _vm.currentOrganization.url,
      "uid": _vm.shareUid
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.module.role === 'referral') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "map-profile-form"
    }
  }, [(_vm.systemFormsLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.systemFormsLoading) ? _c('referral-map-profile-form', {
    attrs: {
      "form-fields": this.flatSchema,
      "fields-map-from-server": _vm.referralColumnsMap
    },
    on: {
      "fieldsMapUpdated": _vm.setColumnsMapReferral,
      "profileMapValidStatusUpdated": _vm.setProfileMapValidStatus
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.module.role === 'referral') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "emails"
    }
  }, [_c('referral-email-settings', {
    attrs: {
      "form-id": _vm.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.module.role === 'referral') ? _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "confirmation"
    }
  }, [_c('referral-confirmation', {
    attrs: {
      "form-id": _vm.id
    }
  })], 1) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('has-changed-modal', {
    on: {
      "publish": function($event) {
        return _vm.publishForm(true)
      }
    }
  }), _vm._v(" "), _c('share-fields-modal', {
    attrs: {
      "field-list": _vm.flatFormItems
    },
    on: {
      "share": _vm.updateSharingSettings
    }
  }), _vm._v(" "), _c('share-fields-with-participant-modal', {
    attrs: {
      "field-list": _vm.flatFormItems
    },
    on: {
      "share": _vm.updateParticipantSharingSettings
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "icon-settings font-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Form Builder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#form-settings",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Settings ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#form_share",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Share ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#map-profile-form",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Map Profile Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#emails",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Emails")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#confirmation",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Confirmation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2363280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/FormBuilder.vue
// module id = 1741
// module chunks = 1